require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-rauchwart.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-rauchwart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-rauchwart!./.cache/json/betreuungseinrichtungen-guessing-rauchwart.json
// module id = 900
// module chunks = 231608221292675